import request from '@/utils/request'

/**
 *
 * 读取职位列表
 * @param {*} argrp
 * 1校园招聘
 * 2社会招聘
 * 3实习生招聘
 * 4内部招聘
 */
export function fetchJobList(argrp, pagenum, rownum, search) {
  return request({
    url: '/sap/bc/zhr/zhr',
    method: 'get',
    params: {
      method: "hr-plans",
      apgrp: argrp,
      pagenum: pagenum,
      rownum: rownum,
      search:search
    }
  })
}




// WEBPACK FOOTER //
// ./src/api/jobList.js